export const isSystemUserByFullName = (userFullName: string): boolean => {
  return userFullName === 'System ';
};
